import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Profil } from '../../../../models/profil';

@Component({
  selector: 'app-edit-profile-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Modifier mon profil</h4>
      <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div class="loader-container" *ngIf="loading">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Mise à jour...</span>
        </div>
        <span class="ms-2">Mise à jour en cours...</span>
      </div>
      <form [formGroup]="profileForm" *ngIf="!loading">
        <div class="mb-3">
          <label class="form-label">Prénom</label>
          <input type="text" class="form-control" formControlName="prenom">
        </div>
        <div class="mb-3">
          <label class="form-label">Nom</label>
          <input type="text" class="form-control" formControlName="nom">
        </div>
        <div class="mb-3">
          <label class="form-label">Email</label>
          <input type="email" class="form-control" formControlName="email">
        </div>
        <div class="mb-3">
          <label class="form-label">Téléphone</label>
          <input type="tel" class="form-control" formControlName="telephone">
        </div>
        <div class="mb-3">
          <label class="form-label">Mot de passe</label>
          <input type="password" class="form-control" placeholder="Laisser vide si vous ne voulez pas modifier le mot de passe" formControlName="password">
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()" [disabled]="loading">Annuler</button>
      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!profileForm.valid || loading">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
        Modifier
      </button>
    </div>
  `,
  styles: [`
    .loader-container {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2rem;
    }
  `]
})
export class EditProfileModalComponent implements OnInit {
  @Input() user!: Profil;
  profileForm: FormGroup;
  loading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder
  ) {
    this.profileForm = this.fb.group({
      prenom: ['', Validators.required],
      nom: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      telephone: ['', Validators.required],
      password: ['']
    });
  }

  ngOnInit() {
    if (this.user) {
      this.profileForm.patchValue(this.user);
    }
  }

  save() {
    if (this.profileForm.valid) {
      this.loading = true;
      this.activeModal.close(this.profileForm.value);
    }
  }
} 